<template>
    <div :class="preCls + 'container-padding'">
        <div :class="preCls + 'content-box'">
            <table-tool-bar>
                <template slot="left">
                    <table-searcher :disabled="loading"
                        v-model="filter.projName"
                        placeholder="请输入项目名称"
                        style="margin-left: 10px;"
                        @search="search"></table-searcher>
                </template>
                <Button v-if="$can('add')"
                    :class="preCls + 'button-margin'"
                    :disabled="loading"
                    type="primary"
                    @click="onClickAdd">新增项目</Button>
            </table-tool-bar>
            <Table ref="mt"
                :columns="columns"
                :data="page.list"
                :loading="loading"
                :height="mtHeight">
                <template v-slot:action="{ row }">
                    <Button v-if="row.recommend == 1 && $can('update')"
                        :disabled="loading"
                        type="default"
                        size="small"
                        style="margin-right: 5px;"
                        @click="rowClickRecommend(row)">取消推荐</Button>
                    <Button v-if="row.recommend != 1 && $can('update')"
                        :disabled="loading"
                        type="default"
                        size="small"
                        style="margin-right: 5px;"
                        @click="rowClickRecommend(row)">推荐</Button>
                    <PoptipButton v-if="$can('update')"
                        :disabled="loading"
                        text="删除"
                        transfer
                        type="default"
                        title="您确定删除这条记录吗？"
                        :ok="() => { rowConfirmDelete(row) }"></PoptipButton>
                </template>
                <template #propertyType="{ row }">
                    <span>
                        {{row.propertyType.split(",").map(id => dict.propertyType.val(id)).join(",")}}
                    </span>
                </template>
            </Table>
            <!-- 底部分页 -->
            <table-pager :total.sync="page.total"
                :pageSize.sync="filter.pageSize"
                :pageNo.sync="filter.pageNo"
                @change="fetch"></table-pager>
            <!-- 弹出层 -->
            <smart-modal v-model="showProjForm"
                title="新增项目"
                :width="800"
                :height="520"
                :maskClosable="false"
                :buttons.sync="projFormBtns"
                @close-by-confirm="search">
                <proj-form v-if="showProjForm"
                    :id="curId"></proj-form>
            </smart-modal>
        </div>
    </div>
</template>
<script>
import { SmartModal } from 'ivux'
import { anchorCell, mapCell, pipeCell } from '_c/grid/renderCell'
import ProjForm from './form'
import { projList, projDelete, recommend } from '@/api/proj-manager'
import Dict from '@/utils/dict'

const fetchData = function() {
    return Dict.get(['property_type'])
}
const PAGE_SIZE = 20

export default {
    access: "projBase",
    name: 'ListProj',
    components: {
        SmartModal,
        ProjForm
    },

    data() {
        return {
            mtHeight: 360,
            loading: false,
            filter: {
                pageNo: 1,
                pageSize: PAGE_SIZE,
                projName: ''
            },
            page: {
                total: 0,
                list: []
            },
            dict: {
                propertyType: Dict.NULL
            },
            showProjForm: false,
            projFormBtns: [],
            curId: ''
        }
    },

    computed: {
        columns() {
            return [{
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 60
                },
                {
                    key: 'projName',
                    title: '项目名称',
                    align: 'left',
                    minWidth: 150,
                    render: anchorCell({
                        click: (row, column, index) => {
                            //   if (this.$can("view")) {
                            this.$router.push({
                                name: 'projectDetail',
                                params: {
                                    id: row.id
                                }
                            })
                            //   } else {
                            //     this.$Message.warning("暂无查看权限, 请联系管理员授权");
                            //   }
                        }
                    })
                },
                {
                    key: 'propertyType',
                    title: '物业类别',
                    align: 'center',
                    minWidth: 150,
                    slot: "propertyType"
                },
                {
                    key: 'averagePrice',
                    title: '均价',
                    align: 'right',
                    minWidth: 150,
                    render: pipeCell('currency')
                },
                {
                    key: 'projAddr',
                    title: '项目地址',
                    align: 'left',
                    minWidth: 180,
                    tooltip: true
                },
                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    slot: 'action',
                    minWidth: 180
                }
            ]
        }
    },
    created() {
        this.fetch()
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },

    methods: {
        fetch() {
            this.loading = true

            Promise.all([projList(this.filter)])
                .then(args => {
                    var [page] = args
                    this.setPageData(page.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        fillData(dictGroup) {
            Object.keys(this.dict).forEach(name => {
                this.dict[name] = dictGroup[name] || Dict.NULL
            })
            console.log(this.dict)
        },
        search() {
            this.page.pageNo = 1
            this.fetch()
        },

        setPageData(data) {
            this.page.list = data.page.list
            this.page.total = parseInt(data.page.totalCount)
        },

        onClickAdd(e) {
            this.curId = ''
            this.showProjForm = true
        },

        rowClickRecommend(row) {
            this.loading = true
            recommend(row.id)
                .then(el => {
                    this.$Message.success(this.$t('tips.update.success'))
                })
                .finally(() => this.fetch())
        },

        rowConfirmDelete(row) {
            this.loading = true
            projDelete(row.id)
                .then(el => {
                    this.$Message.success(this.$t('tips.delete.success'))
                })
                .finally(() => this.fetch())
        }
    },
    beforeRouteEnter(to, from, next) {
        fetchData().then(args => {
            next(vm => vm.fillData(args))
        })
    }
}
</script>
<style lang="less"
    scoped>
</style>